<template>
  <v-dialog
    v-model="enable"
    max-width="320"
    persistent
    >
    <v-card
      class="main--text">
      <v-card-title class="headline">
        登録が完了しました！
      </v-card-title>
      <v-card-text>
        このままお子さまの情報の入力に進みますか？
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          depressed
          rounded
          outlined
          color='primary'
          @click="$emit('break-button-click')"
        >
          あとで入力する
        </v-btn>
        <v-btn
          depressed
          rounded
          outlined
          color="primary"
          @click="$emit('continue-button-click')"
        >
          入力に進む
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    enable: {
      type: Boolean,
      default: false,
      required: true
    }
  }
}
</script>